// Called by : src/App.vue (router-view)
<template>
  
</template>


<script>

export default {

  mounted: function() {

    let token = this.$route.params.token
    if (token) {
      try {
        token = b64_to_utf8(token); // decode base64 token
        // 2 first chars : length of the login
        const loginSize = parseInt(token.substring(0, 2), 10)
        const login = token.substring(2, loginSize + 2)
        const pw = token.substring(loginSize + 2)
        this.$router.push({name: 'connect', params:{login: login, pw: pw}})
      } catch(err) {
        console.error('autoconnect : bad login', err)
        this.$router.push({name: 'connect'})
      }
    }
  },
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/AutoConnect.vue